module.exports = __webpack_public_path__ + "AgeIcon-2103a326afb89686934b36239bd7baba.svg";